import { useTracking } from '@change-corgi/core-react/tracking';

import { useImpactStoryPageData } from 'src/app/pages/impactStory/pageContext';

type Result = ModelHookResult<
	{
		guideArticlesAndLinks: ReadonlyArray<{
			title: string;
			guideLink: string;
		}>;
	},
	{ trackGuideLinkClick: (url: string) => void }
>;

export function useGuidesSection(): Result {
	const {
		data: {
			featureConfig: { guides: guideArticlesAndLinks },
		},
	} = useImpactStoryPageData();
	const track = useTracking();

	// Transform external URLs to internal paths for client-side routing
	const transformedGuideArticlesAndLinks = guideArticlesAndLinks.map((guide) => ({
		...guide,
		guideLink: guide.guideLink.replace(/^https?:\/\/[^/]+/, ''),
	}));

	return {
		data: {
			guideArticlesAndLinks: transformedGuideArticlesAndLinks,
		},
		actions: {
			trackGuideLinkClick: (url: string) => {
				void track('impact_story_page_guide_link_click', { url });
			},
		},
	};
}
